import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductImage
} from '@thd-olt-component-react/product-pod';
import {
  Button,
  CardActions,
  Typography
} from '@one-thd/sui-atomic-components';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const ATCConfirmationProductPod = ({
  itemId
}) => {
  const { store } = useContext(ExperienceContext);
  return (
    <ProductPod
      itemId={itemId}
      storeId={store.storeId}
      hoverDelay={500}
      analyticsData={{
        parent: 'magic-apron',
      }}
      render={(pod) => (
        <div className="sui-flex sui-flex-wrap">
          <div className="sui-basis-1/4 sui-shrink">
            <ProductImage
              itemId={pod.itemId}
              showSecondaryImage={pod.showSecondaryImage}
            />
          </div>
          <div className="sui-basis-3/4 sui-flex sui-gap-2 sui-flex-col sui-flex-wrap sui-pl-4 sui-pb-4">
            <div className="sui-mb-5">
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={4}
                disableShopThisCollection
              />
            </div>
            <div className="sui-flex sui-flex-col sui-flex-wrap sui-gap-2">
              <Typography>Qty: 1</Typography>
              <div>
                <Price
                  itemId={itemId}
                  storeId={store.storeId}
                  basic
                  type="simple"
                  hideBadge
                  hideBulkPrice
                  hideLimitPerOrder
                  hidePromotions
                  hideSavingsText
                  hideRebates
                  omitDetails
                />
              </div>
            </div>
          </div>
          <div className="sui-basis-4/4 sui-grow">
            <CardActions>
              <Button
                variant="primary"
                fullWidth
                target="_parent"
                href="/cart"
              >
                View Cart
              </Button>
            </CardActions>
          </div>
        </div>
      )}
    />
  );
};

ATCConfirmationProductPod.propTypes = {
  itemId: PropTypes.string.isRequired
};

ATCConfirmationProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  Price,
  ProductHeader,
);
